import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMap } from 'react-leaflet';

import { getAllVehiclesAsRack } from '../../../features/assets/assetsSlice';
import { gensetFocusAssetIdSelector, gensetViewportPaddingSelector, setNeedBounding } from '../../../features/map/mapSlice';

const OsmMapGensetBounder = () => {
    const map = useMap();
    const dispatch = useDispatch();
    const focusedAssetId = useSelector(gensetFocusAssetIdSelector);
    const viewportPadding = useSelector(gensetViewportPaddingSelector);
    const rack = useSelector(getAllVehiclesAsRack);

    useEffect(() => {
        if (!map || !focusedAssetId) return;
        const assetData = rack?.[`${focusedAssetId}`];
        if (!assetData?.coreData) {
            dispatch(setNeedBounding(false));
            return;
        }
        const { lat, lng } = assetData.coreData;
        const padding = viewportPadding
            ? {
                paddingTopLeft: [Math.max(0, viewportPadding.left || 0), Math.max(0, viewportPadding.top || 0)],
                paddingBottomRight: [Math.max(0, viewportPadding.right || 0), Math.max(0, viewportPadding.bottom || 0)],
            }
            : { paddingTopLeft: [350, 75], paddingBottomRight: [25, 100] };
        map.fitBounds([[lat, lng], [lat, lng]], padding);
        dispatch(setNeedBounding(false));
    }, [dispatch, focusedAssetId, map, rack, viewportPadding]);

    return null;
};

export default OsmMapGensetBounder;
